import React from 'react';


export default function error(param) {



    return(
        <div className="login-box">

            <section className="content">
                <div className="error-page">

                    <div className="mt-5">
                        <h1 className="headline text-danger mr-5"> ERROR</h1>
                    </div>

                    <div className=" ">
                        <h1><i className="fas fa-exclamation-triangle text-warning mb-5"></i> Oops! 페이지를 찾을 수 없습니다.</h1>

                        <p className="mt-5 text-center">
                            <a href="/schedule"><i className="fas fa-home" /> 메인 페이지로 이동하기</a>
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}